// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let API = require("../reason/common/API.bs.js");
let Next = require("../reason/next/Next.bs.js");
let Api = require("../api");
let RelayEnv = require("../RelayEnv.bs.js");
let AuthSession = require("./AuthSession.bs.js");
let LoginListener = require("../reason/common/UserSession/LoginListener.bs.js");
let Nextjs = require("@sentry/nextjs");
let Stdlib_Nullable = require("@rescript/runtime/lib/js/Stdlib_Nullable.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let RescriptRelay_Query = require("rescript-relay/src/RescriptRelay_Query.bs.js");
let Primitive_exceptions = require("@rescript/runtime/lib/js/Primitive_exceptions.js");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let AuthSessionRelayQuery_graphql = require("../__generated__/AuthSessionRelayQuery_graphql.bs.js");
let AuthSessionRelay_query_graphql = require("../__generated__/AuthSessionRelay_query_graphql.bs.js");

function getHandoffTokenFromURL() {
  let location = window.location;
  return Primitive_option.fromNullable(new URLSearchParams(location.search).get("handoff_token"));
}

function stripHandoffTokenFromURL() {
  let location = window.location;
  let params = new URLSearchParams(location.search);
  params.delete("handoff_token");
  let qs = params.toString();
  let pathname = location.pathname;
  let hash = location.hash;
  let newUrl = pathname + (
    qs === "" ? "" : "?" + qs
  ) + hash;
  Next.SingletonRouter.replace(newUrl, undefined, true);
}

let convertVariables = AuthSessionRelayQuery_graphql.Internal.convertVariables;

let convertResponse = AuthSessionRelayQuery_graphql.Internal.convertResponse;

let convertWrapRawResponse = AuthSessionRelayQuery_graphql.Internal.convertWrapRawResponse;

let use = RescriptRelay_Query.useQuery(convertVariables, AuthSessionRelayQuery_graphql.node, convertResponse);

RescriptRelay_Query.useLoader(convertVariables, AuthSessionRelayQuery_graphql.node, prim => prim);

RescriptRelay_Query.usePreloaded(AuthSessionRelayQuery_graphql.node, convertResponse, prim => prim);

RescriptRelay_Query.fetch_(AuthSessionRelayQuery_graphql.node, convertResponse, convertVariables);

let fetchPromised = RescriptRelay_Query.fetchPromised(AuthSessionRelayQuery_graphql.node, convertResponse, convertVariables);

RescriptRelay_Query.retain(AuthSessionRelayQuery_graphql.node, convertVariables);

let commitLocalPayload = RescriptRelay_Query.commitLocalPayload(AuthSessionRelayQuery_graphql.node, convertVariables, convertWrapRawResponse);

let convertFragment = AuthSessionRelay_query_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, AuthSessionRelay_query_graphql.node, convertFragment, fRef);
}

function updateCurrentAuthSession_(data) {
  commitLocalPayload(RelayEnv.environment, undefined, {
    currentAuthSession: data
  });
}

function useCurrentAuthSession_() {
  let data = use(undefined, "store-only", undefined, undefined);
  return RescriptRelay_Fragment.useFragment(AuthSessionRelay_query_graphql.node, convertFragment, data.fragmentRefs).currentAuthSession;
}

AuthSession.Internal.useCurrentAuthSession_.contents = useCurrentAuthSession_;

async function oneShotReadDataFromStore() {
  let data = await fetchPromised(RelayEnv.environment, undefined, undefined, undefined);
  return (await waitForFragmentData(RelayEnv.environment, data.fragmentRefs)).currentAuthSession;
}

let inFlightCreateSessionPromise = {
  contents: undefined
};

let inFlightLogoutPromise = {
  contents: undefined
};

async function createSession() {
  let p = inFlightCreateSessionPromise.contents;
  if (p !== undefined) {
    return await p;
  }
  let p$1 = Api.createSession();
  inFlightCreateSessionPromise.contents = p$1;
  let results;
  try {
    results = await p$1;
  } catch (raw_e) {
    let e = Primitive_exceptions.internalToException(raw_e);
    console.error(e);
    inFlightCreateSessionPromise.contents = undefined;
    throw e;
  }
  Nextjs.setUser({
    id: results.user.id,
    email: results.user.email
  });
  inFlightCreateSessionPromise.contents = undefined;
  return results;
}

async function logout() {
  let p = inFlightLogoutPromise.contents;
  if (p !== undefined) {
    return await p;
  }
  let p$1 = Api.logout();
  inFlightLogoutPromise.contents = p$1;
  let r;
  try {
    r = await p$1;
  } catch (raw_e) {
    let e = Primitive_exceptions.internalToException(raw_e);
    console.error(e);
    inFlightLogoutPromise.contents = undefined;
    throw e;
  }
  Nextjs.setUser({});
  inFlightLogoutPromise.contents = undefined;
  return r;
}

async function createSession$1() {
  let session;
  try {
    session = await createSession();
  } catch (exn) {
    return updateCurrentAuthSession_({
      __typename: "AuthSessionUnauthenticated",
      dummy: true
    });
  }
  let expiresAt = Date.now() + session.expiresIn * 1000;
  let match = session.user.role;
  return updateCurrentAuthSession_({
    __typename: "AuthSession",
    expiresAt: expiresAt,
    isImpersonated: Stdlib_Nullable.getOr(session.impersonated, false),
    token: session.accessToken,
    user: {
      id: session.user.id,
      role: match === "agent" ? "AGENT" : "CLIENT"
    }
  });
}

AuthSession.Internal.createSession_.contents = createSession$1;

async function readToken() {
  let match = await oneShotReadDataFromStore();
  if (match !== undefined && match.__typename === "AuthSession") {
    return match.token;
  }
}

function loginSuccess(session) {
  let expiresAt = Date.now() + session.expiresIn * 1000;
  Nextjs.setUser({
    id: session.user.id,
    email: session.user.email
  });
  LoginListener.didLogin();
  let match = session.user.role;
  updateCurrentAuthSession_({
    __typename: "AuthSession",
    expiresAt: expiresAt,
    isImpersonated: session.impersonated,
    token: session.accessToken,
    user: {
      id: session.user.id,
      role: match === "agent" ? "AGENT" : "CLIENT"
    }
  });
}

AuthSession.Internal.loginSuccess_.contents = loginSuccess;

async function getWithExpiryCheck_(operationName) {
  let match = await oneShotReadDataFromStore();
  if (match !== undefined) {
    switch (match.__typename) {
      case "AuthSession" :
        if (Date.now() > match.expiresAt) {
          await createSession$1();
          return await readToken();
        } else {
          return match.token;
        }
      case "AuthSessionInitializing" :
        await createSession$1();
        return await readToken();
      case "AuthSessionUnauthenticated" :
      case "__unselected" :
        return;
    }
  } else {
    updateCurrentAuthSession_({
      __typename: "AuthSessionInitializing",
      dummy: true
    });
    let handoffToken = getHandoffTokenFromURL();
    if (handoffToken !== undefined) {
      stripHandoffTokenFromURL();
      let session = await API.redeemHandoffToken(handoffToken);
      if (session !== undefined) {
        loginSuccess(session);
        return await readToken();
      } else {
        await createSession$1();
        return await readToken();
      }
    }
    await createSession$1();
    return await readToken();
  }
}

AuthSession.Internal.getWithExpiryCheck_.contents = getWithExpiryCheck_;

async function logout_() {
  let val;
  try {
    val = await logout();
  } catch (exn) {
    return;
  }
  ((window.location.href = "/login"));
}

AuthSession.Internal.logout_.contents = logout_;

let dummy = "";

exports.dummy = dummy;
/* use Not a pure module */
